<div class="overlay">
  <div class="modal">
    <h2>Escolha o modo de estudo</h2>

    <button class="but" (click)="choose('time')">Modo Estudo</button>
    <button class="but" (click)="choose('queue')">Fila</button>
    <button class="but" (click)="choose('memory')">Jogo da Memória</button>
  </div>
</div>
